// extracted by mini-css-extract-plugin
export default {"table":"ManageCouponCode_table__ZhxLK","icons":"ManageCouponCode_icons__5HvjI","pending":"ManageCouponCode_pending__yKRAq","delivered":"ManageCouponCode_delivered__mQssv"};